export const environment = {
  production: true,
  apiCustomRootUrl: 'https://developmentapi.bcipotterydirect.com/backend/',
  apiCustomServerRootUrl: 'https://developmentapi.bcipotterydirect.com/backend/',
  // apiCustomRootUrl: 'http://192.168.0.208:8000/backend/',
  // apiCustomRootUrl: 'http://127.0.0.1:8000/backend/',
  apiCustomIpAddress: 'https://geolocation-db.com/json/',
  customerUrl: 'https://development.bcipotterydirect.com',
  apiRebate: '',
  s3Acess: {
    accessKeyId: '',
    secretAccessKey: '',
    // region: 'us-west-2',
    // signatureVersion: 'v4'
  },
  // Cloudfront bucket.
  imageBucket: '',
  videoBucket: '',
  teamMemberFolder: 'party/',
  businessUnitFolder: 'party/',
  storeFolder: 'party/',
  taxonomyBanner: 'taxonomy/',
  taxonomyThumbnail: 'taxonomy/',
  taxonomyIcon: 'taxonomy/',
  productFolder: 'items/',
  docUrl: '',
  imageBaseUrl: 'https://d1jcnt89y7y99l.cloudfront.net/',
  videoUrl: '',
  firebaseAccess: {
    apiKey: "",
    authDomain: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: "",
    measurementId: ""
  },
  flipAccess: {
    accessToken: "",
    merchantId: "",
    merchantNameIdentifier: ""
  },
  stipePublicKey: "",
  AWS_S3_XML_FOLDER: "assets/xml",
  isDevServer: true
};
